import { Route } from '@angular/router';
import { LoginComponent } from '@bodyanalytics/authentication-ui';
import { registerAccountRoutes } from '@bodyanalytics/registration-ui';
import { ServerErrorComponent } from '@bodyanalytics/ui-core';

/**
 * The full calendar route tree, defined ONCE and mounted twice below: at the
 * root ('') and under the runtime-tenancy prefix ('t/:slug'), so every deep
 * link works identically on the default portal and on a tenant-branded portal
 * (`/t/iron-athletics/booking-flow/...`).
 *
 * The '' → 'calendar' and '**' → 'calendar' redirects are RELATIVE (no leading
 * slash), so inside the tenant mount they resolve to `/t/:slug/calendar` and
 * the tenant prefix — and therefore the tenant's theme after a hard refresh —
 * is preserved.
 */
const calendarRoutes: Route[] = [
  {
    path: 'calendar',
    loadChildren: () => import('@bodyanalytics/calendar-ui').then(mod => mod.CalendarUiModule),
  },
  { path: 'login', component: LoginComponent },
  { path: 'error', component: ServerErrorComponent },

  {
    path: 'booking',
    loadChildren: () => import('@bodyanalytics/booking-ui').then(mod => mod.bookingUiRoutes),
  },
  // #2386 (founder decision, revised 2026-07-24): the LEGACY calendar flow is the
  // single canonical booking flow. The new 4-step flow's PUBLIC entry points
  // redirect to the legacy event-details page / calendar discovery. Redirects are
  // RELATIVE (no leading slash) so they preserve the `/t/:slug` tenant prefix,
  // and sit BEFORE the lazy mount so they win route matching.
  { path: 'booking-flow/event/:eventId/session', redirectTo: 'calendar/event-details/:eventId' },
  { path: 'booking-flow/event/:eventId', pathMatch: 'full', redirectTo: 'calendar/event-details/:eventId' },
  { path: 'booking-flow', pathMatch: 'full', redirectTo: 'calendar' },
  // The mount stays ONLY for surfaces with no legacy equivalent: private events
  // (#1119 access-code gate + private 4-step flow) and existing
  // `confirmation/:bookingId` deep links. Public flow steps are unreachable —
  // their entry (`session`) redirects above, and flowGuard bounces any deeper
  // deep-link back to `session`, which lands on the same redirect.
  {
    path: 'booking-flow',
    loadChildren: () => import('@bodyanalytics/calendar-booking-feature').then(mod => mod.bookingFlowRoutes),
  },
  {
    path: 'bring-my-truck',
    loadChildren: () => import('@bodyanalytics/bring-my-truck-ui').then(mod => mod.BringMyTruckUiRoutes),
  },
  ...registerAccountRoutes,
  // { path: '**', component: PageNotFoundComponent },
  { path: '', pathMatch: 'full', redirectTo: 'calendar' },
  { path: '**', redirectTo: 'calendar' },
];

export const appRoutes: Route[] = [
  // Tenant-branded mount — must precede the root mount so `/t/:slug/...`
  // never falls through to the root '**' wildcard.
  { path: 't/:slug', children: calendarRoutes },
  ...calendarRoutes,
];
